import { render, staticRenderFns } from "./ShowComment.vue?vue&type=template&id=62b8d9dd&"
import script from "./ShowComment.vue?vue&type=script&lang=js&"
export * from "./ShowComment.vue?vue&type=script&lang=js&"
import style0 from "./ShowComment.vue?vue&type=style&index=0&id=62b8d9dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports